<form (keyup.enter)="submit()" [formGroup]="form">
  <div class="input-row-name">
    <gl-input-container [glPremium]="true">
      <input formControlName="name" normal-input placeholder="name" type="text" data-ctx="input-name" />
    </gl-input-container>
  </div>
  <div class="dimensions">
    <div class="titlePart">
      <span>{{ 'air_container' | translate }}</span>
    </div>
    <div class="input-row">
      <gl-select class="select" formControlName="airType" placeholder="type">
        <gl-option [label]="'type_x'" [value]="1"></gl-option>
        <gl-option [label]="'type_y'" [value]="2"></gl-option>
      </gl-select>
      <gl-input-container [units]="'length'">
        <input
          [numericType]="'float'"
          formControlName="airLengthA"
          normal-input
          placeholder="length_a"
          type="text"
          />
      </gl-input-container>
      <gl-input-container [units]="'length'">
        <input
          [numericType]="'float'"
          formControlName="airWidth"
          normal-input
          placeholder="width"
          type="text"
          />
      </gl-input-container>
    </div>
    <div class="input-row">
      <gl-input-container [units]="'length'">
        <input
          [numericType]="'float'"
          formControlName="airBaseB"
          normal-input
          placeholder="base_b"
          type="text"
          />
      </gl-input-container>
      <gl-input-container [units]="'length'">
        <input
          [numericType]="'float'"
          formControlName="airHeightC"
          normal-input
          placeholder="height_c"
          type="text"
          />
      </gl-input-container>
      <gl-input-container [units]="'length'">
        <input
          [numericType]="'float'"
          formControlName="airHeightD"
          normal-input
          placeholder="height_d"
          type="text"
          />
      </gl-input-container>
    </div>
    <div class="input-row right">
      <div></div>
      <gl-input-container [units]="'weight'">
        <input
          [numericType]="'float'"
          formControlName="airLoadCapacity"
          normal-input
          placeholder="limit"
          type="text"
          />
      </gl-input-container>
      @if (!changeType) {
        <gl-input-container>
          <input
            [numericType]="'float'"
            formControlName="airQuantity"
            min="1"
            number-input
            placeholder="quantity"
            type="number"
            />
        </gl-input-container>
      }
    </div>
    @if (isEdit) {
      <div class="buttonRow">
        @if (isFormChanged) {
          <form [formGroup]="saveLoadingForm">
            @if (!isMyLoadingSpace) {
              @if (isFormChanged && !isMyLoadingSpace) {
                <gl-icon-checkbox
                  [checkboxFormGroup]="saveLoadingForm"
                  [tooltipInfo]="'save_info'"
                  [controlName]="'remember'"
                  [iconName]="'saveIcon'"
                ></gl-icon-checkbox>
              }
            }
          </form>
        }
        @if ((changeType && !isLoadingSpaceEquel()) || areStopsChanged()) {
          <div
            class="saveInfo"
            >
            {{ 'save_information' | translate }}
          </div>
        }
        <button
          data-ctx="button-submit"
          type="submit"
          (click)="submit()"
          outline-button
          [class.saveButton]="(changeType && !isLoadingSpaceEquel()) || areStopsChanged()"
          >
          @if (isMyLoadingSpace || changeType) {
            {{ 'save' | translate }}
          }
          @if (!isMyLoadingSpace && !changeType) {
            {{ 'add' | translate }}
          }
        </button>
        @if (!hideDelete) {
          <button
            type="reset"
            (click)="changeType ? emitDeleteLoadingSpace() : resetForm()"
            outline-icon-button
            >
            <gl-icon name="delete"></gl-icon>
          </button>
        }
        <button type="button" (click)="reload()" outline-icon-button>
          <gl-icon name="startArrangement"></gl-icon>
        </button>
      </div>
    }
  </div>
</form>
